<template>
  <header>
    <TheTopHeader/>

    <div class="header">
      <TheDesktopHeader
        v-if="$vuetify.breakpoint.mdAndUp"
        @toggleMenu="toggleMenu"
        @synchronize="synchronize"
        :is-online="isOnline"
        :main-website-url="mainWebsiteUrl"
        :favorites-number="favoritesNumber"
      />

      <TheMobileHeader
        v-else
        @toggleMenu="toggleMenu"
        @synchronize="synchronize"
        :is-online="isOnline"
        :main-website-url="mainWebsiteUrl"
        :favorites-number="favoritesNumber"
      />

    </div>

    <transition
      name="fade"
      @after-enter="toggleMain"
      @before-leave="toggleMain"
    >
      <TheMenuContainer
        v-if="menuIsOpen"
        class="menu-container"
      />
    </transition>
  </header>
</template>

<script>
  const TheMenuContainer = () => import(/* webpackPrefetch: true */'../../menu/TheMenuContainer.vue')

  import TheTopHeader from './TheTopHeader.vue'
  import TheDesktopHeader from './TheDesktopHeader.vue'
  import TheMobileHeader from './TheMobileHeader.vue'

  export default {
    name: 'TheHeader',

    components: {
      TheTopHeader,
      TheDesktopHeader,
      TheMobileHeader,
      TheMenuContainer,
    },

    data() {
      return {
        menuIsOpen: false,
      }
    },

    computed: {
      isOnline() {
        return this.$store.state.isOnline
      },

      mainWebsiteUrl() {
        return `https://www.lausanne-tourisme.ch/${this.$i18n.locale}`
      },

      favoritesNumber() {
        return this.$store.state.objects.favorites.length
      },
    },

    methods: {
      toggleMenu(e) {
        this.menuIsOpen = e
      },
      toggleMain() {
        const main = document.querySelector('.v-main')

        main.style.display = main.style.display === 'none'
          ? 'block'
          : 'none'
      },

      synchronize() {
        this.$emit('synchronize')
      }
    },
  }
</script>

<style lang="sass" scoped>
  .header
    width: 100%
    height: 80px
    position: relative
    z-index: 20
    box-shadow: 0 3px 25px 0 rgba(32, 33, 36, 0.28)

    .theme--light.v-btn:hover::before
      opacity: 0

    .fade-enter-active, .fade-leave-active
      transition: opacity 0.6s

    .fade-enter, .fade-leave-to
      opacity: 0

  @media (max-width: 960px)
    .header
      height: 60px
</style>
